<template>
  <v-container>
    <v-row cols="12">
      <v-col xs="12">
        <v-card>
          <v-btn @click="dialog = true" fab fixed bottom right dark color="indigo">
            <v-icon dark>add</v-icon>
          </v-btn>
          <v-card-title class="headline">Mensagens de Atendimento</v-card-title>
          <v-card-text>
            <List               
              @edit="edit"              
            />
          </v-card-text>
          <Create            
            @closeDialog="closeDialog"  
            :dialog="dialog"
          />
          <Edit 
            v-if="selectedMessage" 
            :dialog="editDialog" 
            :selectedMessage="selectedMessage" 
            @closeEdit="editDialog = false"
          />
        </v-card>
        
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import List from './List';
  import Create from './Create';
  import Edit from './Edit';
export default {
  components: {
    List,
    Create,
    Edit
  },
  name: 'index',
  methods: {
    closeDialog() {
      this.dialog = false;
      return;
    },
    edit (data) {
      this.selectedMessage = data;
      this.editDialog = true;   
      return;
    },
  },
  data () {
    return {
      dialog: false,
      editDialog: false,
      selectedMessage: null
    }
  }
}
</script>

<style lang="css" scoped>
</style>